module.exports = __webpack_public_path__ + "static/media/fullscreen.f448ffc5.svg";